import { Typography } from "@mui/material";
import { useContext } from "react";
import { ButtonComponent } from "../ButtonComponent/ButtonComponent";
import { ApplicationContext } from "../../ApplicationProvider";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ErrorModalComponent = function (_a) {
    var message = _a.message;
    var setShowDialog = useContext(ApplicationContext).setShowDialog;
    return /*#__PURE__*/ _jsxs("div", { children: [/*#__PURE__*/ _jsx(Typography, { className: "standard-para py-2", children: message ? message : "Error encountered, please click on \"report bug\"." }), /*#__PURE__*/ _jsx(ButtonComponent, { id: "error-modal-close", buttonType: 'primary', click: function () { return setShowDialog(false); }, buttonText: 'Ok', buttonStyle: 'mx-0 py-2' })] });
};
